import {
  ContextsService,
  type DataEntryDto,
  type DataEntrySummaryDto,
} from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/inference-client';

/** The newest saves of a test conversation; enough to debug a test, which is a handful of turns. */
const PAGE_SIZE = 100;

/** Names what an agent saved, among everything its conversation keeps. */
export const SAVE_DATA_TOOL = 'save_data';

/**
 * What the agent saved in the conversation, newest first, without the values. The tool results it
 * also keeps are already shown, input and output, in the run's details.
 */
export async function listSavedData(contextId: string): Promise<DataEntrySummaryDto[]> {
  const response = await ContextsService.listDataEntries({
    client: inferenceHttp,
    throwOnError: true,
    path: { contextId },
    query: { pageSize: PAGE_SIZE, toolName: SAVE_DATA_TOOL },
  });
  return response.data.data;
}

export async function getDataEntry(contextId: string, key: string): Promise<DataEntryDto> {
  const response = await ContextsService.getDataEntry({
    client: inferenceHttp,
    throwOnError: true,
    path: { contextId, key },
  });
  return response.data;
}
